/**
 * HomePage - Главная страница
 */

import React, { useEffect, useState } from "react";
import { GuestLayout } from "../../components/layouts";
import { Toast } from "../../components/UI";
import {
    HeroStats,
    VideoSection,
    NewsSection,
    FeaturesSection,
    SupportSection,
    GuestFooter,
} from "../../components/Guest";
import { GUEST_SECTION_IDS } from "../../data/guestPageData";

const HomePage = () => {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        if (!toast) {
            return undefined;
        }

        const timer = setTimeout(() => setToast(null), 4000);
        return () => clearTimeout(timer);
    }, [toast]);

    const hero = (
        <section className="guest-hero" id={GUEST_SECTION_IDS.home}>
            <div className="title-container">
                <h1 className="main-title main-title--accent">
                    MEDIEVAL <br /> <span className="main-title">ROLEPLAY</span>
                </h1>
                <p className="desc-title">
                    Уникальный текстовый ролевой проект в сеттинге
                    Средневекового фентези.
                </p>

                <div className="buttons-container buttons-container-center">
                    <button className="button-signUp">
                        <a href="/register">ЗАРЕГИСТРИРОВАТЬСЯ</a>
                    </button>
                    <button className="button-downloadLauncher">
                        <a href="/med_setup.exe" download={true}>
                            СКАЧАТЬ ЛАУНЧЕР
                        </a>
                    </button>
                </div>

                <div className="social-icons-container">
                    <a
                        href="https://vk.com/medievalrpnet"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button className="vk-icon" type="button"></button>
                    </a>
                    <a
                        href="https://t.me/medieval_rp"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <button
                            className="telegram-icon"
                            type="button"
                        ></button>
                    </a>
                </div>
            </div>

            <HeroStats />
        </section>
    );

    return (
        <GuestLayout landing hero={hero} showFooter={false}>
            <div className="guest-container">
                <VideoSection />
                <NewsSection />
                <FeaturesSection />
                <SupportSection
                    onSuccess={(message) =>
                        setToast({ message, type: "success" })
                    }
                    onError={(message) =>
                        setToast({ message, type: "error" })
                    }
                />
            </div>
            <GuestFooter />

            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    duration={4000}
                />
            )}
        </GuestLayout>
    );
};

export default HomePage;
